import { useState } from 'react';
import {
  PREDEFINED_AMOUNTS,
  isValidAmount,
  getAmountValidationError,
  getSubscriptionAvailabilityMessage,
} from './donationConfig';

export const useAmountValidation = () => {
  const [amountError, setAmountError] = useState('');
  const [subscriptionWarning, setSubscriptionWarning] = useState('');

  const handleAmountSelect = (amount, donationType, state) => {
    const { setDonationAmount, setCustomAmount, setIsCustomAmountManuallyEdited } = state;
    setDonationAmount(amount);
    setCustomAmount(amount.toString());
    setAmountError('');
    const subscriptionMsg = getSubscriptionAvailabilityMessage(amount, donationType);
    setSubscriptionWarning(subscriptionMsg || '');
    setIsCustomAmountManuallyEdited(false);
  };

  const handleCustomAmountChange = (e, donationType, state) => {
    const { setCustomAmount, setDonationAmount, setIsCustomAmountManuallyEdited } = state;
    const value = e.target.value;
    if (value === '') {
      setCustomAmount('');
      setDonationAmount(null);
      setIsCustomAmountManuallyEdited(true);
      return;
    }
    if (/^\d+$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (isValidAmount(numValue)) {
        setCustomAmount(value);
        setIsCustomAmountManuallyEdited(true);
        setAmountError('');
        const subscriptionMsg = getSubscriptionAvailabilityMessage(numValue, donationType);
        setSubscriptionWarning(subscriptionMsg || '');
        if (PREDEFINED_AMOUNTS.includes(numValue)) {
          setDonationAmount(numValue);
        } else {
          setDonationAmount(null);
        }
      } else {
        const errorMsg = getAmountValidationError(numValue);
        setAmountError(errorMsg || '');
      }
    }
  };

  const isValidForProceed = (customAmount) => {
    return customAmount && isValidAmount(parseInt(customAmount, 10)) && !amountError;
  };

  const clearAmountValidation = () => {
    setAmountError('');
    setSubscriptionWarning('');
  };

  return {
    amountError,
    subscriptionWarning,
    handleAmountSelect,
    handleCustomAmountChange,
    isValidForProceed,
    clearAmountValidation,
    setAmountError,
    setSubscriptionWarning,
  };
};
